import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';

export interface CarePlanStatusOption {
  code: string;
  label: string;
}

@Component({
  selector: 'bn-care-plan-status-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, Select],
  templateUrl: './care-plan-status-select.component.html',
})
export class CarePlanStatusSelectComponent {
  readonly options = input.required<CarePlanStatusOption[]>();
  readonly value = input<string | null>(null);
  readonly placeholder = input('');
  readonly ariaLabel = input.required<string>();
  readonly loading = input(false);
  readonly disabled = input(false);
  readonly valueChange = output<string>();
}
